<template>
  <b-container class="pt-2">
    <b-table
        hover
        responsive
        :items="getShopCarts"
        :fields="fields"
        :current-page="shopCartList.currentPage"
        ref="device_table"
        :per-page="shopCartList.perPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="table-bordered table-hover"
        show-empty>
      <template v-slot:empty="scope">
        <h6 class="text-center">Корзина отсутствует</h6>
      </template>
      <template v-slot:table-busy>
        <loading-spinner/>
      </template>
      <template v-slot:cell(interaction)="row">
        <b-button variant="outline-primary"
                  title="Просмотр"
                  @click="goToDetailPage(row.item.id)">
          <b-icon-eye-fill/>
        </b-button>
      </template>
    </b-table>
    <div class="d-flex">
      <div class="col-md-2 pl-0">
        <b-form-select
            v-model="shopCartList.perPage"
            class="text-light border-secondary bg-secondary">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
        </b-form-select>
      </div>
      <span class="align-self-center d-none d-lg-block mb-2">записей на страницу</span>
      <b-pagination
          v-model="shopCartList.currentPage"
          class="my-0 ml-auto mb-2"
          :total-rows="shopCartList.totalCount"
          :per-page="shopCartList.perPage"
          aria-controls="template-table"
          @input="getShopCarts">
      </b-pagination>
    </div>
  </b-container>
</template>
<script>
import shopCartService from "@/modules/shop-cart-service";

export default {
  name: 'user-favorite-list',
  data() {
    return {
      sortBy: 'id',
      sortDesc: false,
      fields: [
        {
          key: 'id', label: 'ID', sortable: true
        },
        {
          key: 'name', label: 'Название товара', sortable: true
        },
        {
          key: 'price', label: 'Цена', sortable: true
        },
        {
          key: 'quantity', label: 'Количество', sortable: true
        },
        {
          key: 'interaction', label: 'Взаимодействие'
        }
      ],
      shopCartList: {
        perPage: 10,
        currentPage: 1,
        totalCount: 0,
      }
    };
  },
  created() {
    document.title = this.$route.meta.title;
  },
  methods: {
    getShopCarts(context) {
      return shopCartService.getShopCart(this.$route.params.id, context.perPage, context.currentPage, context.sortBy,
          context.sortDesc ? "DESC" : "ASC")
          .then(response => {
            this.shopCartList.totalCount = response.data.totalCount;
            return response.data.productList;
          })
          .catch(error => {
            this.$bvToast.toast('Не удалось загрузить корзину пользователя' + (error.response == null ? '' : ` (код ${error.response.status})`), {
              title: 'Ошибка',
              variant: 'danger',
              autoHideDelay: 5000,
              appendToast: true
            });
          });
    },
    goToDetailPage(productId) {
      this.$router.push(`/users/${this.$route.params.id}/shop-cart/${productId}`);
    }
  }
}
</script>
